/**
 * GlowSmile Custom Cart Drawer
 * AJAX cart with Kaching Bundles grouping and tiered rewards
 */
(function () {
  'use strict';

  var drawer = document.getElementById('gs-cart');
  var overlay = document.getElementById('gs-cart-overlay');
  var closeBtn = document.getElementById('gs-cart-close');
  var bodyEl = document.getElementById('gs-cart-body');
  var totalEl = document.getElementById('gs-cart-total');
  var countEl = document.getElementById('gs-cart-count');
  var rewardsMsgEl = document.getElementById('gs-cart-rewards-msg');
  var fill1 = document.getElementById('gs-cart-fill-1');
  var fill2 = document.getElementById('gs-cart-fill-2');
  var ms1 = document.getElementById('gs-cart-ms-1');
  var ms2 = document.getElementById('gs-cart-ms-2');
  var footerEl = document.getElementById('gs-cart-footer');

  if (!drawer) return;

  var currentGroups = [];

  /* ── Config from data attributes ── */
  var t1 = parseFloat(drawer.dataset.tierOneThreshold) || 30;
  var t2 = parseFloat(drawer.dataset.tierTwoThreshold) || 50;
  var label1 = drawer.dataset.tierOneLabel || 'FREE GIFT';
  var label2 = drawer.dataset.tierTwoLabel || 'FREE SHIPPING';
  var msgProgress = drawer.dataset.rewardMsgProgress || 'Spend {amount} more for {next_reward}!';
  var msgComplete = drawer.dataset.rewardMsgComplete || 'Free shipping & Free gift unlocked!';
  var moneyFmt = drawer.dataset.moneyFormat || '€{{amount_with_comma_separator}}';

  /* ── Static upsell rules (fallback from section blocks) ── */
  var upsellRules = [];
  try {
    var rulesEl = document.getElementById('gs-cart-upsell-rules');
    if (rulesEl) upsellRules = JSON.parse(rulesEl.textContent);
  } catch (e) { /* ignore */ }

  /* ── Dynamic Kaching deal cache ── */
  var dealCache = {};
  var fetchingHandles = {};

  /* ── Open / Close ── */
  var renderTimer = null;
  var cartBusy = false;
  function open() {
    drawer.classList.add('gs-cart--open');
    overlay.classList.add('gs-cart-overlay--open');
    document.body.style.overflow = 'hidden';
    /* Debounce the render — if multiple cart/add calls happen in sequence
       (Kaching adds main + gifts), only render once they've all settled */
    clearTimeout(renderTimer);
    renderTimer = setTimeout(fetchAndRender, 500);
  }

  function close() {
    drawer.classList.remove('gs-cart--open');
    overlay.classList.remove('gs-cart-overlay--open');
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('gs-cart--open')) close();
  });

  /* ── Intercept cart icon clicks ── */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/cart"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (href === '/cart' || href === '/cart/' || href.match(/\/cart\/?$/)) {
      e.preventDefault();
      e.stopPropagation();
      open();
    }
  }, true);

  /* ── Auto-open: debounced — waits for Kaching to finish all cart/add calls ── */
  function scheduleCartOpen() {
    open();
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
    if (urlStr.indexOf('cart/add') !== -1) {
      return originalFetch.apply(this, arguments).then(function (response) {
        if (response.ok) scheduleCartOpen();
        return response;
      });
    }
    return originalFetch.apply(this, arguments);
  };

  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._gsCartUrl = url;
    return origXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._gsCartUrl && this._gsCartUrl.indexOf('cart/add') !== -1) {
      var self = this;
      this.addEventListener('load', function () {
        if (self.status >= 200 && self.status < 300) scheduleCartOpen();
      });
    }
    return origXHRSend.apply(this, arguments);
  };

  /* ── Listen for theme cart events ── */
  document.documentElement.addEventListener('cart:change', function () {
    if (drawer.classList.contains('gs-cart--open')) fetchAndRender();
  });
  document.addEventListener('cart:refresh', function () {
    if (drawer.classList.contains('gs-cart--open')) fetchAndRender();
  });

  /* ── Intercept form submits to prevent /cart navigation ── */
  /* Only for pages WITHOUT Kaching — Kaching handles its own forms completely */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;
    if (form.closest('product-form')) return;
    if (document.querySelector('.kaching-bundles')) return;
    e.preventDefault();
    var formData = new FormData(form);
    originalFetch('/cart/add.js', {
      method: 'POST',
      body: formData
    }).then(function (r) { return r.json(); }).then(function () {
      open();
    }).catch(function () {});
  });

  /* ── Format money ── */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var decimal = parts[1];
    return moneyFmt
      .replace('{{amount_with_comma_separator}}', whole + ',' + decimal)
      .replace('{{amount}}', whole + '.' + decimal)
      .replace('{{amount_no_decimals}}', parts[0])
      .replace('{{amount_no_decimals_with_comma_separator}}', whole)
      .replace('{{amount_with_apostrophe_separator}}', whole.replace(/\./g, "'") + '.' + decimal);
  }

  /* ── Fetch Kaching deal bars for a product handle ── */
  function getProductHandle(item) {
    if (item.handle) return item.handle;
    if (item.url) {
      var m = item.url.match(/\/products\/([^?#/]+)/);
      if (m) return m[1];
    }
    return '';
  }

  function fetchDealBars(handle, callback) {
    /* Check sessionStorage cache first */
    var cacheKey = 'gs_deals_' + handle;
    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        dealCache[handle] = JSON.parse(cached);
        callback();
        return;
      }
    } catch (e) { /* sessionStorage unavailable */ }

    /* Prevent duplicate fetches */
    if (fetchingHandles[handle]) return;
    fetchingHandles[handle] = true;

    originalFetch('/products/' + handle, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var match = html.match(/class="kaching-bundles-deal-block-settings"[^>]*>([\s\S]*?)<\/script>/);
        if (match) {
          try {
            var settings = JSON.parse(match[1]);
            if (settings.dealBars && settings.dealBars.length > 0) {
              dealCache[handle] = settings.dealBars;
              try { sessionStorage.setItem(cacheKey, JSON.stringify(settings.dealBars)); } catch (e) {}
            }
          } catch (e) {}
        }
        fetchingHandles[handle] = false;
        callback();
      })
      .catch(function () {
        fetchingHandles[handle] = false;
      });
  }

  function fetchAllDealsAndRenderUpsells(cart) {
    var handles = [];
    cart.items.forEach(function (item) {
      var kb = item.properties && item.properties.__kaching_bundles;
      if (kb) {
        var handle = getProductHandle(item);
        if (handle && handles.indexOf(handle) === -1 && !dealCache[handle]) {
          handles.push(handle);
        }
      }
    });

    if (handles.length === 0) {
      renderUpsells(cart);
      return;
    }

    var done = 0;
    handles.forEach(function (handle) {
      fetchDealBars(handle, function () {
        done++;
        if (done === handles.length) renderUpsells(cart);
      });
    });
  }

  function renderUpsells(cart) {
    /* Insert upsell nudges into already-rendered items */
    var groups = currentGroups;
    groups.forEach(function (group) {
      if (!group.main) return;
      var handle = getProductHandle(group.main);
      var kb = group.main.properties && group.main.properties.__kaching_bundles;
      if (!kb || !handle) return;

      try {
        var data = typeof kb === 'string' ? JSON.parse(kb) : kb;
        var currentBarId = data.bar || data.bid;
        var bars = dealCache[handle];
        if (!bars) return;

        var currentIdx = -1;
        for (var i = 0; i < bars.length; i++) {
          if (bars[i].id === currentBarId) { currentIdx = i; break; }
        }

        if (currentIdx >= 0 && currentIdx < bars.length - 1 && upgradeEnabledHandles.indexOf(handle) !== -1) {
          var nextBar = bars[currentIdx + 1];
          /* Find the item's element in the DOM and insert upsell after it */
          var itemEl = bodyEl.querySelector('[data-line-key="' + group.main.key + '"]');
          if (itemEl) {
            /* Check if upsell already inserted */
            var next = itemEl.nextElementSibling;
            if (next && next.classList.contains('gs-cart__upsell')) return;

            /* Encode upgrade data on the button */
            var upgradeData = {
              keys: getGroupKeys(group).split(','),
              variantId: group.main.variant_id,
              handle: handle,
              dealId: data.deal,
              nextBarId: nextBar.id,
              buyQty: nextBar.buyQuantity || nextBar.quantity || 1,
              getQty: nextBar.getQuantity || 0,
              isBxgy: nextBar.dealBarType === 'bxgy',
              sellingPlan: group.main.selling_plan_allocation ? group.main.selling_plan_allocation.selling_plan.id : null
            };

            var upsellDiv = document.createElement('div');
            upsellDiv.className = 'gs-cart__upsell';
            upsellDiv.innerHTML =
              '<p class="gs-cart__upsell-msg">Upgrade to <strong>' + nextBar.title + '</strong></p>' +
              '<button type="button" class="gs-cart__upsell-btn" data-upgrade="' + encodeURIComponent(JSON.stringify(upgradeData)) + '">Upgrade &rarr;</button>';
            itemEl.parentNode.insertBefore(upsellDiv, itemEl.nextSibling);
          }
        }
      } catch (e) {}
    });

    /* Attach upgrade click handlers — full AJAX bundle swap */
    bodyEl.querySelectorAll('[data-upgrade]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        btn.textContent = 'Upgrading...';
        btn.style.pointerEvents = 'none';

        var data = JSON.parse(decodeURIComponent(btn.dataset.upgrade));
        var bundleId = Math.random().toString(36).substring(2, 6);

        /* Step 1: Remove current bundle items */
        var updates = {};
        data.keys.forEach(function (k) { updates[k] = 0; });

        originalFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          /* Step 2: Add the main items */
          var mainProps = { __kaching_bundles: JSON.stringify({ deal: data.dealId, main: true, id: bundleId, bar: data.nextBarId }) };
          var mainItem = { id: data.variantId, quantity: data.buyQty, properties: mainProps };
          if (data.sellingPlan) mainItem.selling_plan = data.sellingPlan;

          return originalFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [mainItem] })
          });
        }).then(function () {
          /* Step 3a: Add bxgy free items (same product, e.g. Oral Probiotic) */
          if (data.isBxgy && data.getQty > 0) {
            var freeProps = { __kaching_bundles: JSON.stringify({ id: bundleId, deal: data.dealId, bar: data.nextBarId, main: true, bxgy: true }) };
            var freeItem = { id: data.variantId, quantity: data.getQty, properties: freeProps };
            if (data.sellingPlan) freeItem.selling_plan = data.sellingPlan;

            return originalFetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: [freeItem] })
            });
          }
        }).then(function () {
          fetchAndRender();
        }).catch(function () {
          fetchAndRender();
        });
      });
    });
  }

  /* ── Products that support AJAX upgrade (bxgy same-product deals only) ── */
  var upgradeEnabledHandles = ['oral-defense-probiotics', 'oral-defense-probiotics-braces'];

  function getGroupKeys(group) {
    var keys = [group.main.key];
    if (group.gifts) {
      group.gifts.forEach(function (g) { keys.push(g.key); });
    }
    return keys.join(',');
  }

  /* ── Fetch cart and render ── */
  function fetchAndRender() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function (err) { console.error('Cart fetch error:', err); });
  }

  /* ── Render full cart ── */
  function render(cart) {
    /* Update count badges everywhere */
    countEl.textContent = cart.item_count;
    document.querySelectorAll('cart-count, .wl-header__cart-count, .header__cart-count cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) {
        el.style.display = '';
        el.classList.remove('opacity-0');
      } else {
        el.style.display = 'none';
        el.classList.add('opacity-0');
      }
    });

    /* Update total */
    totalEl.textContent = formatMoney(cart.total_price);

    /* Update rewards bar */
    updateRewards(cart.total_price / 100);

    /* Show/hide footer and rewards when cart is empty */
    var rewardsEl = document.getElementById('gs-cart-rewards');
    if (cart.item_count === 0) {
      footerEl.style.display = 'none';
      if (rewardsEl) rewardsEl.style.display = 'none';
    } else {
      footerEl.style.display = '';
      if (rewardsEl) rewardsEl.style.display = '';
    }

    /* Group Kaching bundles */
    var groups = groupItems(cart.items);
    currentGroups = groups;

    /* Render items */
    if (cart.item_count === 0) {
      bodyEl.innerHTML =
        '<div class="gs-cart__empty">' +
          '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
          '<p>Your cart is empty</p>' +
        '</div>';
      return;
    }

    var html = '';
    groups.forEach(function (group) {
      /* Main item */
      html += renderItem(group.main);
      /* Broken bundle warning */
      if (group.broken) {
        var brokenHandle = getProductHandle(group.main);
        var brokenMsg = 'Bundle broken — items below are no longer free';
        if (ORAL_PROBIOTIC_CONFIGS[brokenHandle]) {
          var brokenTotal = group.main.quantity;
          (group.extras || []).forEach(function (e) { brokenTotal += e.quantity; });
          if (brokenTotal === 4) {
            brokenMsg = 'Add 1 for <span class="gs-cart__bundle-tag">Buy 3, get 2 FREE</span>, or remove 1 for <span class="gs-cart__bundle-tag">Buy 2, get 1 FREE</span>';
          } else if (brokenTotal === 2) {
            brokenMsg = 'Add 1 for <span class="gs-cart__bundle-tag">Buy 2, get 1 FREE</span>';
          } else if (brokenTotal > 5) {
            brokenMsg = 'Remove ' + (brokenTotal - 5) + ' for <span class="gs-cart__bundle-tag">Buy 3, get 2 FREE</span>';
          } else {
            brokenMsg = 'Adjust quantity to restore your bundle deal';
          }
        }
        html += '<div class="gs-cart__bundle-warning">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>' +
          '<span>' + brokenMsg + '</span>' +
          '</div>';
      }
      /* Static upsell nudge (fallback for non-Kaching products) */
      var staticUpsell = findUpsellRule(group.main);
      if (staticUpsell) {
        html += renderStaticUpsell(staticUpsell);
      }
      /* Extra items (ex-gifts, bundle broken) */
      if (group.extras && group.extras.length) {
        group.extras.forEach(function (extra) {
          html += renderItem(extra);
        });
      }
      /* Gift sub-items */
      if (group.gifts && group.gifts.length) {
        group.gifts.forEach(function (gift) {
          html += renderGift(gift);
        });
      }
    });
    bodyEl.innerHTML = html;
    cartBusy = false;

    /* Fetch Kaching deals and render dynamic upsells */
    fetchAllDealsAndRenderUpsells(cart);

    /* Attach event listeners */
    bodyEl.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (cartBusy) return;
        cartBusy = true;
        var item = btn.closest('.gs-cart__item');
        if (item) item.classList.add('gs-cart__item--loading');

        var key = btn.dataset.lineKey;
        var delta = parseInt(btn.dataset.qtyChange, 10);
        var currentQty = parseInt(btn.parentNode.querySelector('.gs-cart__qty-val').textContent, 10);
        var newQty = currentQty + delta;
        if (newQty < 0) newQty = 0;

        /* If qty hits 0, treat as delete — remove bundle gifts too */
        if (newQty === 0) {
          var bundleGroup = findBundleGroupByMainKey(key);
          if (bundleGroup && bundleGroup.gifts.length > 0) {
            removeBundleGroup(bundleGroup, item);
            return;
          }
        }

        /* Check if this is part of a broken oral probiotic bundle */
        var brokenGroup = findBrokenOralProbioticGroup(key);
        if (brokenGroup) {
          var totalQty = getTotalBrokenQty(brokenGroup, key, newQty);
          if (totalQty >= 2) {
            rebundleOralProbiotic(brokenGroup, 2);
            return;
          }
        }

        changeQty(key, newQty, item);
      });
    });

    bodyEl.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (cartBusy) return;
        cartBusy = true;
        var item = btn.closest('.gs-cart__item');
        if (item) item.classList.add('gs-cart__item--loading');
        var key = btn.dataset.remove;

        /* Check if this is part of a broken oral probiotic bundle */
        var brokenGroup = findBrokenOralProbioticGroup(key);
        if (brokenGroup) {
          var totalQty = getTotalBrokenQty(brokenGroup, key, 0);
          if (totalQty >= 2) {
            rebundleOralProbiotic(brokenGroup, 2);
            return;
          }
        }

        /* Check if this is a main bundle item — if so, remove all gifts too */
        var bundleGroup = findBundleGroupByMainKey(key);
        if (bundleGroup && bundleGroup.gifts.length > 0) {
          removeBundleGroup(bundleGroup, btn.closest('.gs-cart__item'));
        } else {
          changeQty(key, 0, btn.closest('.gs-cart__item'));
        }
      });
    });
  }

  /* ── Broken Oral Probiotic bundle helpers ── */
  var ORAL_PROBIOTIC_CONFIGS = {
    'oral-defense-probiotics': { variant: 57262402732364, deal: 'qQ0p', bars: { 2: 'j5-S', 3: '7-G3' } },
    'oral-defense-probiotics-braces': { variant: 57291468308812, deal: 'qQ0p', bars: { 2: 'j5-S', 3: '7-G3' } }
  };
  /* Selling plan is read from the cart item, not hardcoded */

  function findBrokenOralProbioticGroup(key) {
    for (var i = 0; i < currentGroups.length; i++) {
      var g = currentGroups[i];
      if (!g.broken || !g.main) continue;
      var handle = getProductHandle(g.main);
      if (!ORAL_PROBIOTIC_CONFIGS[handle]) continue;
      if (g.main.key === key) return g;
      for (var j = 0; j < (g.extras || []).length; j++) {
        if (g.extras[j].key === key) return g;
      }
    }
    return null;
  }

  function getTotalBrokenQty(group, changedKey, newQty) {
    var total = 0;
    var allItems = [group.main].concat(group.extras || []);
    allItems.forEach(function (item) {
      if (item.key === changedKey) {
        total += newQty;
      } else {
        total += item.quantity;
      }
    });
    return total;
  }

  function rebundleOralProbiotic(group, totalQty) {
    var handle = getProductHandle(group.main);
    var config = ORAL_PROBIOTIC_CONFIGS[handle];
    if (!config) return;

    /* Determine the exact deal tier */
    var buyQty, getQty, barId;
    if (totalQty === 3) {
      buyQty = 3; getQty = 2; barId = config.bars[3];
    } else if (totalQty === 2) {
      buyQty = 2; getQty = 1; barId = config.bars[2];
    } else {
      return; /* No matching tier */
    }

    var bundleId = Math.random().toString(36).substring(2, 6);

    /* Step 1: Remove all broken bundle items */
    var updates = {};
    updates[group.main.key] = 0;
    (group.extras || []).forEach(function (e) { updates[e.key] = 0; });
    (group.gifts || []).forEach(function (g) { updates[g.key] = 0; });

    /* Read selling plan from the original item (null if no subscription) */
    var sellingPlan = group.main.selling_plan_allocation
      ? group.main.selling_plan_allocation.selling_plan.id
      : null;

    originalFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      /* Step 2: Add main items */
      var mainProps = { __kaching_bundles: JSON.stringify({ deal: config.deal, main: true, id: bundleId, bar: barId }) };
      var mainItem = { id: config.variant, quantity: buyQty, properties: mainProps };
      if (sellingPlan) mainItem.selling_plan = sellingPlan;
      return originalFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [mainItem] })
      });
    }).then(function () {
      /* Step 3: Add free bxgy items */
      var freeProps = { __kaching_bundles: JSON.stringify({ id: bundleId, deal: config.deal, bar: barId, main: true, bxgy: true }) };
      var freeItem = { id: config.variant, quantity: getQty, properties: freeProps };
      if (sellingPlan) freeItem.selling_plan = sellingPlan;
      return originalFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [freeItem] })
      });
    }).then(function () {
      setTimeout(fetchAndRender, 300);
    }).catch(function () {
      fetchAndRender();
    });
  }

  /* ── Group items by Kaching bundle ID ── */
  function groupItems(items) {
    var bundleMap = {};
    var standalone = [];

    items.forEach(function (item) {
      var kb = item.properties && item.properties.__kaching_bundles;
      if (kb) {
        try {
          var data = typeof kb === 'string' ? JSON.parse(kb) : kb;
          var bundleId = data.id;
          if (!bundleId) { standalone.push(item); return; }
          if (!bundleMap[bundleId]) bundleMap[bundleId] = { main: null, extras: [], gifts: [] };
          if ((data.bxgy || data.gift) && item.discounted_price === 0) {
            bundleMap[bundleId].gifts.push(item);
          } else if (data.main && !data.bxgy && !data.gift) {
            /* True main item */
            bundleMap[bundleId].main = item;
          } else {
            /* Ex-gift or extra item (bundle broken — discount removed) */
            bundleMap[bundleId].extras.push(item);
          }
        } catch (e) {
          standalone.push(item);
        }
      } else {
        standalone.push(item);
      }
    });

    var groups = [];
    Object.keys(bundleMap).forEach(function (id) {
      var g = bundleMap[id];
      if (g.main) {
        /* Check if bundle is broken: extras exist (ex-gifts at full price) */
        g.broken = g.extras.length > 0;
        groups.push(g);
      } else if (g.extras.length > 0) {
        /* No main item — all are orphaned, show as standalone */
        g.extras.forEach(function (item) { standalone.push(item); });
        g.gifts.forEach(function (gift) { standalone.push(gift); });
      } else {
        g.gifts.forEach(function (gift) { standalone.push(gift); });
      }
    });
    standalone.forEach(function (item) {
      groups.push({ main: item, gifts: [], extras: [] });
    });

    return groups;
  }

  /* ── Render main line item ── */
  function renderItem(item) {
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') : '';
    var comparePrice = item.original_price > item.final_price ? formatMoney(item.original_price * item.quantity) : '';
    var finalPrice = formatMoney(item.final_line_price);
    var savings = item.original_line_price > item.final_line_price
      ? formatMoney(item.original_line_price - item.final_line_price)
      : '';
    var variant = item.variant_title || '';

    return (
      '<div class="gs-cart__item" data-line-key="' + item.key + '">' +
        '<div class="gs-cart__item-img">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '</div>' +
        '<div class="gs-cart__item-info">' +
          '<div class="gs-cart__item-top">' +
            '<p class="gs-cart__item-title">' + item.product_title + '</p>' +
            '<button type="button" class="gs-cart__item-remove" data-remove="' + item.key + '" aria-label="Remove">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
            '</button>' +
          '</div>' +
          (variant ? '<p class="gs-cart__item-variant">' + variant + '</p>' : '') +
          '<div class="gs-cart__item-bottom">' +
            '<div class="gs-cart__qty">' +
              '<button type="button" data-qty-change="-1" data-line-key="' + item.key + '">−</button>' +
              '<span class="gs-cart__qty-val">' + item.quantity + '</span>' +
              '<button type="button" data-qty-change="1" data-line-key="' + item.key + '">+</button>' +
            '</div>' +
            '<div class="gs-cart__item-price">' +
              (comparePrice ? '<span class="gs-cart__item-compare">' + comparePrice + '</span>' : '') +
              finalPrice +
              (savings ? '<span class="gs-cart__item-savings">(Save ' + savings + ')</span>' : '') +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  /* ── Render free gift sub-item ── */
  function renderGift(item) {
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '';
    var dealTitle = '';
    if (item.discounts && item.discounts.length) {
      dealTitle = item.discounts[0].title;
    }
    var originalPrice = item.original_price > 0 ? formatMoney(item.original_price * item.quantity) : '';

    return (
      '<div class="gs-cart__gift">' +
        '<div class="gs-cart__gift-img">' +
          '<span class="gs-cart__gift-qty">' + item.quantity + '</span>' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '</div>' +
        '<div class="gs-cart__gift-info">' +
          '<span class="gs-cart__gift-badge">FREE GIFT</span>' +
          '<p class="gs-cart__gift-title">' + item.product_title + '</p>' +
          (dealTitle ? '<p class="gs-cart__gift-deal">' + dealTitle + '</p>' : '') +
        '</div>' +
        '<div class="gs-cart__gift-price">' +
          (originalPrice ? '<span class="gs-cart__gift-original">' + originalPrice + '</span>' : '') +
          'Free' +
        '</div>' +
      '</div>'
    );
  }

  /* ── Find matching upsell rule for a cart item ── */
  function findUpsellRule(item) {
    if (!upsellRules.length || !item) return null;
    for (var i = 0; i < upsellRules.length; i++) {
      var rule = upsellRules[i];
      var handle = item.handle || (item.url && item.url.split('/products/')[1] && item.url.split('/products/')[1].split('?')[0]) || '';
      if (handle === rule.handle && item.quantity == parseInt(rule.triggerQty, 10)) {
        return rule;
      }
    }
    return null;
  }

  /* ── Render upsell nudge ── */
  function renderStaticUpsell(rule) {
    var url = rule.buttonUrl || '/products/' + rule.handle;
    return (
      '<div class="gs-cart__upsell">' +
        '<p class="gs-cart__upsell-msg">' + rule.message + '</p>' +
        '<a href="' + url + '" class="gs-cart__upsell-btn">' + rule.buttonText + '</a>' +
      '</div>'
    );
  }

  /* ── Find bundle group by main item key ── */
  function findBundleGroupByMainKey(key) {
    for (var i = 0; i < currentGroups.length; i++) {
      if (currentGroups[i].main && currentGroups[i].main.key === key && currentGroups[i].gifts.length > 0) {
        return currentGroups[i];
      }
    }
    return null;
  }

  /* ── Remove entire bundle group (main + all gifts) ── */
  function removeBundleGroup(group, el) {
    if (el) el.classList.add('gs-cart__item--loading');
    var updates = {};
    updates[group.main.key] = 0;
    group.gifts.forEach(function (gift) { updates[gift.key] = 0; });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
      })
      .catch(function () { fetchAndRender(); });
  }

  /* ── Change quantity via AJAX ── */
  function changeQty(key, qty, el) {
    if (el) el.classList.add('gs-cart__item--loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        /* Dispatch theme event so other components update */
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
      })
      .catch(function () {
        fetchAndRender();
      });
  }

  /* ── Update rewards bar ── */
  function updateRewards(totalEur) {
    /* Segment 1: 0 → t1 */
    var pct1 = Math.min(100, (totalEur / t1) * 100);
    fill1.style.width = pct1 + '%';

    /* Segment 2: t1 → t2 */
    var pct2 = totalEur <= t1 ? 0 : Math.min(100, ((totalEur - t1) / (t2 - t1)) * 100);
    fill2.style.width = pct2 + '%';

    /* Milestone states */
    if (totalEur >= t1) ms1.classList.add('gs-cart__milestone--done');
    else ms1.classList.remove('gs-cart__milestone--done');

    if (totalEur >= t2) ms2.classList.add('gs-cart__milestone--done');
    else ms2.classList.remove('gs-cart__milestone--done');

    /* Message */
    if (totalEur >= t2) {
      rewardsMsgEl.innerHTML = msgComplete;
    } else if (totalEur >= t1) {
      var remaining = (t2 - totalEur).toFixed(2).replace('.', ',');
      rewardsMsgEl.innerHTML = msgProgress
        .replace('{amount}', '<span>&euro;' + remaining + '</span>')
        .replace('{next_reward}', label2);
    } else {
      var remaining1 = (t1 - totalEur).toFixed(2).replace('.', ',');
      rewardsMsgEl.innerHTML = msgProgress
        .replace('{amount}', '<span>&euro;' + remaining1 + '</span>')
        .replace('{next_reward}', label1);
    }
  }

  /* ── Expose open/close globally for other scripts ── */
  window.GsCart = { open: open, close: close, refresh: fetchAndRender };
})();
